import React from 'react'
import TextField from '@material-ui/core/TextField'
import { useForm, Controller } from 'react-hook-form'
import { SkywatchDialog } from '../../PopUps/SkywatchDialog'
import FlexView from 'react-flexview/lib'
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail'
import { ElevatedCircle } from '../../Core/ElevatedCircle'
import {
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  RadioGroup,
  Divider,
} from '@material-ui/core'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../../services/FirebaseService'
import NameAutocomplete from './NameAutocomplete'
import PhoneNumberAutoComplete from './PhoneNumberAutoComplete'
import EmailAutocomplete from './EmailAutocomplete'
import PolicyNumberAutocomplete from './PolicyNumberAutocomplete'
import DividerWithText from '../../Core/DividerWithText'

export const GetUserExtendedFilterPopup = ({
  open,
  title,
  body,
  onConfirm,
  onCancel,
  ...props
}) => {
  const { register, errors, getValues, triggerValidation, control } = useForm()
  const handleClose = () => {
    onCancel && onCancel()
  }

  const selectUser = async (user) => {
    if (!!user) {
      handleClose()
      onConfirm && onConfirm(user)
    }
  }

  return (
    <SkywatchDialog
      open={open}
      closeDialog={handleClose}
      maxWidth={'xs'}
      circleHeader={
        <ElevatedCircle>
          {' '}
          <AlternateEmailIcon className="blue" />{' '}
        </ElevatedCircle>
      }
      closeTitle={title}>
      <FlexView column>
        <div className="text-title blue bold margin-top-basic textcenter margin-bottom-basic">
          {title}
        </div>
        <div className="text-body black margin-top-small textcenter">
          Search by
        </div>
        <div className="text-body black margin-top-basic margin-bottom-basic">
          Insert the insured's email
        </div>
        <EmailAutocomplete selectUser={selectUser} />
        <DividerWithText>Or</DividerWithText>
        <div className="text-body black margin-top-basic margin-bottom-basic">
          Insured's policy number
        </div>
        <PolicyNumberAutocomplete selectUser={selectUser} />
        <DividerWithText>Or</DividerWithText>
        <div className="text-body black margin-top-basic margin-bottom-basic">
          Insured's name
        </div>
        <NameAutocomplete selectUser={selectUser} />
        <DividerWithText>Or</DividerWithText>
        <div className="text-body black margin-top-basic margin-bottom-basic">
          Insured's phone number
        </div>
        <PhoneNumberAutoComplete selectUser={selectUser} />
        <div
          onClick={handleClose}
          className="margin-bottom-basic text-body textcenter gray underline clickable">
          Close
        </div>
      </FlexView>
    </SkywatchDialog>
  )
}
